export default {
  state: {
    customizeMetalData: [
      {
        shape: "如意",
        name: "如意五福雙獅",
        code: "A",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 30
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意雙龍獻寶",
        code: "B",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意五福齊臨",
        code: "C",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 30
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意金福元寶",
        code: "D",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 36
          },
          gift: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意雙龍拜塔",
        code: "E",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 24
          }
        }
      },
      {
        shape: "如意",
        name: "如意雙龍獻珠",
        code: "F",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意圓融",
        code: "G",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意神龜",
        code: "H",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "桃心",
        name: "桃心雙龍",
        code: "I",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 2,
            textLimit: 6,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 55
          },
          gift: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "桃心",
        name: "桃心五福",
        code: "J",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 55
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "桃心",
        name: "桃心福全",
        code: "K",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 55
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "春秋",
        name: "春秋龍鳳",
        code: "L",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 6,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "春秋",
        name: "春秋雙龍",
        code: "M",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "大福",
        code: "N",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "葫蘆",
        name: "福如雙鳳牡丹",
        code: "O",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "葫蘆",
        name: "福如雙龍獻珠",
        code: "P",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "葫蘆",
        name: "福如九品蓮",
        code: "Q",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "大福九品蓮",
        code: "R",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "如意九品蓮",
        code: "S",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 30
          },
          godName: {
            lineLimit: 1,
            textLimit: 15,
            maxFontsize: 30
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "百花如意",
        code: "T",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 30
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "元寶",
        name: "雙龍元寶",
        code: "U",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 5,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 9,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "祥龍獻福",
        code: "V",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "雙鳳牡丹",
        code: "W",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "龍福齊天",
        code: "X",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 9,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "大龍大福",
        code: "Y",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 1,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "大福道",
        code: "Z",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "週歲鎖片",
        code: "AA",
        accessory: [5],
        way: ["D"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 11,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 36
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "方框",
        name: "週歲生日獎牌",
        code: "AB",
        accessory: [5],
        way: ["E"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 13,
            maxFontsize: 20
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 30
          },
          gift: {
            lineLimit: 1,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "方框",
        name: "結婚 祝壽 記念金牌",
        code: "AC",
        accessory: [5],
        way: ["E"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 13,
            maxFontsize: 20
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 1,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "大統帥",
        code: "ZA",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "如意",
        name: "傳統金牌",
        code: "AD",
        accessory: [5],
        way: ["H"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 30
          },
          godName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "圓框",
        name: "招財進寶",
        code: "AE",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 16
          }
        }
      },
      {
        shape: "扇子",
        name: "濟公扇",
        code: "AF",
        accessory: [5],
        way: ["F", "G"]
      },
      {
        shape: "扇子",
        name: "媽祖扇",
        code: "AG",
        accessory: [5],
        way: ["G"]
      },
      {
        shape: "方框",
        name: "四方福聚",
        code: "AH",
        accessory: [5],
        way: ["E"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 9,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "春秋",
        name: "伽藍韋馱護法",
        code: "AI",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 1,
            textLimit: 5,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "春秋",
        name: "雙龍賜福",
        code: "AJ",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 1,
            textLimit: 12,
            maxFontsize: 16
          }
        }
      },
      {
        shape: "大福",
        name: "鴻福",
        code: "AK",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 1,
            textLimit: 12,
            maxFontsize: 16
          }
        }
      },
      {
        shape: "大福",
        name: "天福",
        code: "AL",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 13,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "龍鳳圓福",
        code: "AM",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 13,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "大福",
        name: "雙福",
        code: "AN",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 13,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "元寶",
        name: "福運元寶",
        code: "AO",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 5,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 9,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 5,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "圓框",
        name: "鴻福呈祥",
        code: "AP",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 1,
            textLimit: 12,
            maxFontsize: 16
          }
        }
      },
      {
        shape: "圓框",
        name: "雙魚荷花",
        code: "AQ",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 8,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 10,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "圓框",
        name: "雙龍如意",
        code: "AR",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 5,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 12,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "葫蘆",
        name: "財福葫蘆(直)",
        code: "AS",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 8,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 6,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "葫蘆",
        name: "財福葫蘆(橫)",
        code: "AT",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 6,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 6,
            maxFontsize: 50
          },
          gift: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 20
          }
        }
      },
      {
        shape: "春秋",
        name: "翔龍賜福",
        code: "AU",
        accessory: [1, 2, 3, 4],
        way: ["A", "B", "C"],
        textSetting: {
          templeName: {
            lineLimit: 1,
            textLimit: 5,
            maxFontsize: 25
          },
          godName: {
            lineLimit: 2,
            textLimit: 7,
            maxFontsize: 40
          },
          gift: {
            lineLimit: 1,
            textLimit: 10,
            maxFontsize: 16
          }
        }
      }
    ]
  },
  getters: {
    customizeMetalData: state => {
      return state.customizeMetalData;
    },
    customizeMetalDataByShape: ({ customizeMetalData }) => {
      return shape => {
        return customizeMetalData.filter(i => i.shape === shape);
      };
    },
    defaultComponentCodeByShape: ({ customizeMetalData }) => {
      return shape => {
        return customizeMetalData.filter(i => i.shape === shape)[0].code;
      };
    },
    customizeMetalNameByComponentCode: ({ customizeMetalData }) => {
      return code => {
        return customizeMetalData.filter(i => i.code === code)[0].name;
      };
    },
    defaultAccessoryByComponentCode: ({ customizeMetalData }) => {
      return code => {
        return customizeMetalData.find(i => i.code === code).accessory[0];
      };
    },
    accessoryByComponentName: ({ customizeMetalData }) => {
      return name => {
        return customizeMetalData.find(i => i.name === name).accessory;
      };
    },
    textSettingByComponentCode: ({ customizeMetalData }) => {
      return code => {
        return customizeMetalData.find(i => i.code === code).textSetting;
      };
    },
    customizeMetalByComponentCode: ({ customizeMetalData }) => {
      return code => {
        return customizeMetalData.filter(i => i.code === code)[0];
      };
    },
    wayByComponentName: ({ customizeMetalData }) => {
      return name => {
        return customizeMetalData.find(i => i.name === name).way;
      };
    },
    isCustomizeByComponentCode: ({ customizeMetalData }) => {
      return code => {
        return !!customizeMetalData.find(i => i.code === code).textSetting;
      };
    }
  }
};
